<template>
  <v-container
    class="pa-0 max-width-md"
  >
    <!-- {{ form.watchProps.oficioDocResponse }}
    <br>
    {{ form.oficioPdfResponse }} -->
    <!-- {{ form.signer }} -->
    <div class="d-flex flex-wrap mt-4 mx-4 mx-md-0">
      <h2>
        {{ $t('Outbox.CreateEdoc') }}
      </h2>
      <v-spacer />
      <v-btn
        class="mr-2"
        color="white"
        @click="showProgress"
      >
        {{ $t('Workflow.PresentProgress') }}
      </v-btn>
      <!-- 下載公函模板 -->
      <template v-if="$config.isBrowser && templateDocs && templateDocs.length === 1">
        <v-btn
          color="white"
          @click="downloadOficioTemplate(templateDocs[0])"
        >
          {{ $t('Outbox.downloadTemplate') }}
        </v-btn>
      </template>
      <template v-if="$config.isBrowser && templateDocs && templateDocs.length > 1">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="white"
              v-bind="attrs"
              v-on="on"
            >
              {{ $t('Outbox.downloadTemplate') }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="templateDoc in templateDocs"
              :key="templateDoc.index"
              @click="downloadOficioTemplate(templateDoc)"
            >
              <v-list-item-title>{{ templateDoc.orgFileName }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </div>
    <br>
    <!-- <v-card
      v-show="form.issueEntities.length > 0"
      class="mx-auto mb-4 pa-4"
      max-width="600"
    >
      <v-select
        v-model="form.issueEntityId"
        :items="form.issueEntities"
        item-value="id"
        :item-text="item => item.abbr + ' - ' + $chPtObjData('chinName', item)"
        hide-details
        :label="$t('Outbox.IssueEntity')"
      />
    </v-card> -->
    <v-stepper
      v-model="mStep"
      vertical
    >
      <!-- <v-stepper-step
        :complete="mStep > 1"
        step="1"
        editable
      >
        {{ $t('Outbox.ReceiveDept') }}
      </v-stepper-step>

      <v-stepper-content step="1">
        <s-create-step-receive-entity
          v-if="!(form.issueEntities.length > 0 && form.issueEntityId === null)"
          ref="stepReceiveEntity"
          v-model="form"
          :entities="entities"
        />

        <br>
        <v-btn
          :disabled="(form.issueEntities.length > 0 && form.issueEntityId === null)"
          color="primary"
          class="mb-2"
          @click="mStep = 2"
        >
          {{ $t('TaskList.NextStep') }}
        </v-btn>
      </v-stepper-content> -->

      <v-stepper-step
        :complete="mStep > 1"
        step="1"
        editable
      >
        {{ $t('Outbox.UploadDocAndAttachment') }}
      </v-stepper-step>
      <v-stepper-content step="1">
        <!--
        <template v-if="businessCode === BUSINESS_CODE.OFICIO">
          <s-create-step-upload-doc-ofc
            ref="fileUploadStep"
            v-model="form"
            :entities="selectedEntityObjs"
            :today="today"
          />
        </template>
        <template v-else>
          -->
        <s-create-step-upload-doc
          ref="fileUploadStep"
          v-model="form"
          :entities="selectedEntityObjs"
          :today="today"
        />
        <!--
        </template>
        -->

        <br><br>

        <v-btn
          color="primary"
          class="mb-2"
          @click="mStep = 2"
        >
          {{ $t('TaskList.NextStep') }}
        </v-btn>
      </v-stepper-content>

      <v-stepper-step
        :complete="mStep > 2"
        step="2"
        editable
      >
        {{ $t('Outbox.Signer') }}（{{ $t('Outbox.eSign') }}）
      </v-stepper-step>
      <v-stepper-content step="2">
        <template v-if="businessCode === BUSINESS_CODE.OFICIO">
          <s-create-step-signer-ofc
            v-model="form"
          />
        </template>
        <template v-else>
          <s-create-step-signer
            v-model="form"
          />
        </template>
        <br>
        <v-btn
          color="primary"
          class="mb-2"
          @click="mStep = 3"
        >
          {{ $t('TaskList.NextStep') }}
        </v-btn>
      </v-stepper-content>

      <!-- <v-stepper-step
        :complete="mStep > 4"
        step="4"
        editable
      >
        {{ $t('Outbox.LabelSample') }}
      </v-stepper-step>
      <v-stepper-content step="4">
        <s-create-step-tag v-model="form" />

        <v-btn
          color="primary"
          class="mb-2"
          @click="mStep = 5"
        >
          {{ $t('TaskList.NextStep') }}
        </v-btn>
      </v-stepper-content> -->

      <v-stepper-step
        step="3"
        editable
      >
        {{ $t('Outbox.UploadFile') }}
      </v-stepper-step>
      <v-stepper-content step="3">
        <template v-if="businessCode === BUSINESS_CODE.OFICIO">
          <s-create-step-present-ofc
            v-model="form"
            @uploadSuccess="onUploadSuccess"
          />
        </template>
        <template v-else>
          <s-create-step-present
            v-model="form"
            @uploadSuccess="onUploadSuccess"
          />
        </template>
      </v-stepper-content>
    </v-stepper>
  </v-container>
</template>

<script>

// import SCreateStepReceiveEntity from './components/SCreateSteps/SCreateStepReceiveEntity'
// import SCreateStepTag from './components/SCreateSteps/SCreateStepTag'
import SCreateStepSigner from './components/SCreateSteps/SCreateStepSigner'
import SCreateStepSignerOfc from './components/SCreateSteps/SCreateStepSignerOfc'
import SCreateStepUploadDoc from './components/SCreateSteps/SCreateStepUploadDoc'
// import SCreateStepUploadDocOfc from './components/SCreateSteps/SCreateStepUploadDocOfc'
import SCreateStepPresent from './components/SCreateSteps/SCreateStepPresent'
import SCreateStepPresentOfc from './components/SCreateSteps/SCreateStepPresentOfc'
import { OUTBOX_OFICIO_TYPE, BUSINESS_CODE } from '@/constant/constant'
import outboxApi from '@/api/outbox/outbox'
import { staffModule } from '@/store/moduleName'
import systemApi from '@/api/general/system'
import datetimeUtil from '@/utils/datetimeUtil'
import { mapGetters, mapState } from 'vuex'

// function getAdministrativeSupportEntities (inst) {
//   outboxApi.administrativeSupportEntities(resp => {
//     if (resp.status === 201 || resp.status === 200) {
//       inst.form.issueEntities = resp.data
//     }
//   })
// }

function setToday (inst) {
  systemApi.getServerDateTime(rsp => {
    inst.today = datetimeUtil.cutTime(rsp)
  })
}

// function getDefaultDocNo (inst) {
//   let defaultDocNo = 'OFI/'
//   if (inst.form.docTypesId === OUTBOX_OFICIO_TYPE.OFICIO_CIRCULAR) {
//     defaultDocNo = 'OFC/'
//   }
//   return defaultDocNo + datetimeUtil.getYear(inst.today)
// }

function setDefaultDocNo (inst) {
  // inst.form.watchProps.docNo = getDefaultDocNo(inst)
}

// function getEntities (inst) {
//   outboxApi.getGovEntities(OUTBOX_ENTITY_SOURCE_TYPE.APM, resp => {
//     if (resp.status === 201 || resp.status === 200) {
//       inst.entities = resp.data
//     }
//   })
// }

export default {
  components: {
    // SCreateStepReceiveEntity,
    // SCreateStepTag,
    SCreateStepSigner,
    SCreateStepSignerOfc,
    SCreateStepUploadDoc,
    // SCreateStepUploadDocOfc,
    SCreateStepPresent,
    SCreateStepPresentOfc
  },
  props: {
    businessCode: {
      type: String,
      default: BUSINESS_CODE.ESIGN
    }
  },
  data: () => {
    return {
      templateDocs: [], // { templateStorageCode: null, templateFileId: null,}
      today: null,
      mStep: 1,
      entities: [],
      form: {
        watchProps: {
          docNo: null,
          selectedEntities: ['0-0'],
          ccEntities: [],
          labelTypeId: 1,
          oficioDocResponse: [],
          mergePdfResponse: [],
          isReply: false,
          senderOficioNo: [],
          sendDate: []
        },
        groupEntities: [],
        title: null,
        docTypesId: OUTBOX_OFICIO_TYPE.OFICIO,
        signer: null,
        nextStaff: null,
        nextStaffObj: null,
        isUrgent: false,
        isDirectSendToEDocX: false,
        oficioPdfResponse: [],
        attachResponse: [],
        refResponse: [],
        isPDFGenerated: false,
        isGenerating: false,
        issueEntities: [],
        issueEntityId: null,
        issueSubunitEntityId: null
      },
      BUSINESS_CODE
    }
  },
  computed: {
    selectedEntities () {
      return this.form.watchProps.selectedEntities
    },
    selectedEntityObjs () {
      let result = []
      this.form.watchProps.selectedEntities.forEach(id => {
        let entityId = parseInt(id.split('-')[1])
        let entity = this.form.groupEntities.find(element => element.id === entityId)
        if (entity) { result.push(entity) }
      })
      return result
    },
    watchProps () {
      return this.form.watchProps
    },
    docTypesId () {
      return this.form.docTypesId
    },
    attachResponse () {
      return this.form.attachResponse
    },
    ...mapGetters(staffModule, {
      defaultNextStaff: 'getDefaultNextStaff'
    }),
    ...mapState(
      {
        info: state => state[staffModule].info
      }
    )
  },
  watch: {
    today: function (val) {
      setDefaultDocNo(this)
    },
    docTypesId: function (val, oldVal) {
      // if (val !== oldVal) {
      //   let defaultDocNo = getDefaultDocNo(this)
      //   let oldDefaultDocNo = ''
      //   if (defaultDocNo.includes('OFI')) {
      //     oldDefaultDocNo = defaultDocNo.replace('OFI', 'OFC')
      //   } else {
      //     oldDefaultDocNo = defaultDocNo.replace('OFC', 'OFI')
      //   }
      //   this.form.watchProps.docNo = this.form.watchProps.docNo.replace(oldDefaultDocNo, defaultDocNo)
      // }
    },
    selectedEntities: function (val) {
      if (val.length > 1) {
        this.form.docTypesId = OUTBOX_OFICIO_TYPE.OFICIO_CIRCULAR
      } else {
        this.form.docTypesId = OUTBOX_OFICIO_TYPE.OFICIO
      }
    },
    watchProps: {
      handler: function (val) {
        this.form.isPDFGenerated = false
      },
      deep: true
    },
    defaultNextStaff: function (val) {
      this.form.nextStaff = val
    },
    attachResponse: function (val) {
      val.forEach(resp => {
        // let entityPrefixs = /^___\d+___/.exec(resp.name)
        let entitySuffixs = /___\d+___.pdf$/i.exec(resp.name)
        if (entitySuffixs) {
          // let entityId = parseInt(entityPrefixs[0].substring(3, entityPrefixs[0].length - 3))
          let entityId = parseInt(entitySuffixs[0].substring(3, entitySuffixs[0].length - 7))
          this.$refs.stepReceiveEntity.selectEntity(entityId)
          resp.response.entityId = entityId
        }
      })
    }
  },
  created () {
    this.$store.dispatch(staffModule + '/loadDefaultNextStaff')
    // getEntities(this)
    setToday(this)
    this.getOficioTemplate()
    // getAdministrativeSupportEntities(this)
  },
  methods: {
    showProgress () {
      let progressOption = {
        showEndTask: true,
        businessCodes: [this.businessCode],
        backLink: this.businessCode === BUSINESS_CODE.OFICIO ? '/outbox/Create' : '/eSign'
      }
      // this.setProgressOption(progressOption)
      this.$router.push({
        path: '/workflow/List',
        query: progressOption
      })
    },
    onUploadSuccess () {
      this.resetForm()
    },
    resetForm () {
      let f = this.form
      let p = f.watchProps
      p.docNo = null
      setDefaultDocNo(this)
      // p.selectedEntities = []
      p.ccEntities = []
      // p.labelTypeId = null
      p.oficioDocResponse = []
      p.mergePdfResponse = []
      p.isReply = false
      p.senderOficioNo = []
      p.sendDate = []

      f.title = null
      f.docTypesId = OUTBOX_OFICIO_TYPE.OFICIO
      f.signer = null
      f.nextStaff = this.defaultNextStaff
      f.isUrgent = false
      f.isDirectSendToEDocX = false
      f.oficioPdfResponse = []
      f.attachResponse = []
      f.refResponse = []
      f.isPDFGenerated = false
      f.isGenerating = false
      // f.issueEntities = []
      f.issueEntityId = null
      // f.issueSubunitEntityId = null
      this.mStep = 1
      this.$refs.fileUploadStep.clearFile()
    },
    getOficioTemplate () {
      outboxApi.getOficioTemplate_v2(resp => {
        if (resp.status === 201 || resp.status === 200) {
          this.templateDocs = resp.data
        }
      }, this.businessCode)
    },
    downloadOficioTemplate (templateDoc) {
      outboxApi.downloadFile((resp, fileExtension) => {
        if (resp.status === 201 || resp.status === 200) {
          const url = window.URL.createObjectURL(new Blob([resp.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'template.' + fileExtension)
          link.click()
          window.URL.revokeObjectURL(url)
        }
      }, templateDoc.documentStorageCode, templateDoc.id)
    }
  }
}
</script>
